import * as React from 'react';
import * as styles from './styles.css';

import { Header2, InlineText1, InlineText2 } from '@cian/ui-kit/typography';

import { Desktop, NotDesktop } from '../Responsive';
import { InfoTooltip } from '../InfoTooltip';
import { Tooltip } from '../Tooltip';
import { FaqIcon } from '../FaqIcon';

const tooltipText =
  'По количеству посещений сайта cian.ru пользователями Сети интернет по данным LiveInternet в разделе «Недвижимость» по состоянию на 12 марта 2020 года';

export function Trust() {
  return (
    <div className={styles['container']}>
      <h3 className={styles['title']}>
        <Header2>
          Циан — сервис по недвижимости №1 в России{' '}
          <span className={styles['faq']}>
            <Desktop>
              <InfoTooltip>
                <InlineText2>{tooltipText}</InlineText2>
              </InfoTooltip>
            </Desktop>
            <NotDesktop>
              <Tooltip master={<FaqIcon />}>
                <InlineText2>{tooltipText}</InlineText2>
              </Tooltip>
            </NotDesktop>
          </span>
        </Header2>
      </h3>
      <InlineText1>
        В мире мы занимаем 10 место среди сервисов недвижимости по версии SimilarWeb. У нас около 15 млн уникальных
        пользователей в месяц и 2,5 млн объявлений по всей стране
      </InlineText1>
    </div>
  );
}
